export const zh = {
  // ── Brand & Topbar ──
  'brand.tag': 'IIT TERMINAL',
  'brand.title': 'Investment Intelligence Tracker',
  'brand.subtitle': 'Professional multi-asset intelligence workspace for OCR-ledger analytics',
  'theme.aria': '颜色方案选择',
  'theme.default': '默认深灰',
  'theme.bloomberg': 'Bloomberg',
  'theme.coolGray': 'Cool Gray',
  'account.signOut': 'Sign Out',
  'account.admin': 'Administrator',
  'account.user': 'User',

  // ── Nav tabs (desktop) ──
  'nav.overview': 'Overview',
  'nav.documents': 'Documents',
  'nav.workspace': 'Workspace',
  'nav.analytics': 'Analytics',
  'nav.talker': 'Talker',
  'nav.monitor': 'Monitor',
  'nav.configure': 'Configure',

  // ── Nav tabs (mobile) ──
  'nav.mobile.overview': '概览',
  'nav.mobile.workspace': '工作台',
  'nav.mobile.analytics': '分析',
  'nav.mobile.talker': '问答',

  // ── Auth ──
  'auth.checking': '正在检查登录状态',
  'auth.title': '用户登录',
  'auth.hint': '请先登录后再进入 Investment Intelligence Tracker。',
  'auth.username': '用户名',
  'auth.password': '密码',
  'auth.usernamePlaceholder': '请输入用户名',
  'auth.passwordPlaceholder': '请输入密码',
  'auth.login': '登录',
  'auth.loggingIn': '登录中...',
  'auth.enterCredentials': '请输入用户名和密码',
  'auth.loginFailed': '登录失败',
  'auth.welcomeBack': '欢迎回来，{name}',

  // ── Security / Encryption ──
  'security.checking': '正在检查加密状态',
  'security.title': '系统解锁',
  'security.hint': '系统已启用存储加密，请输入主密钥以解锁数据。',
  'security.warning': '此密钥用于加密所有资产数据，请妥善保管。丢失密钥将无法恢复数据。',
  'security.masterKey': '主密钥',
  'security.keyPlaceholder': '请输入主密钥',
  'security.unlock': '解锁系统',
  'security.unlocking': '解锁中...',
  'security.unlocked': '系统已成功解锁',
  'security.migrated': '主密钥已接受，数据库将在下次访问时加密',
  'security.unlockFailed': '解锁失败',
  'security.enterKey': '请输入主密钥',
  'security.logout': '退出登录',

  // ── Overview ──
  'overview.marketPulse': '市场脉搏',
  'overview.pulseHint.fx': '按最新汇率对比前一可用交易日',
  'overview.pulseHint.normal': '按最近两个可用交易日收盘值对比',
  'overview.marketValue': '{label}市值（USD）',
  'overview.dividend': '{label}累计分红（USD）',
  'overview.realizedProfit': '{label}已实现盈亏（USD）',
  'overview.interest': '{label}当前区间贷款利息（USD）',
  'overview.marketValueHint': '当前按"{label}"口径展示',
  'overview.dividendHint': '仅汇总"{label}"资产的累计分红',
  'overview.realizedHint': '仅汇总"{label}"资产的卖出实现损益',
  'overview.interestHintAll': '按当前时间范围汇总全组合贷款利息',
  'overview.interestHintPartial': '已归属 {matched} 笔，另有 {unassigned} 笔未分配',
  'overview.interestHintScoped': '按当前时间范围 + "{label}"资产归集',
  'overview.formula.marketValue.title': '组合总市值（USD）',
  'overview.formula.marketValue.body': '组合总市值（USD） = Σ(当前持仓数量 × 估算价格 × 当前币种兑 USD 汇率)，已卖出部分不计入。',
  'overview.formula.dividend.title': '累计分红 / 已实现盈亏（USD）',
  'overview.formula.dividend.body': '累计分红与已实现盈亏分开统计；已实现盈亏只来自卖出交易，不包含分红，二者再按当前汇率快照折算为 USD。',
  'overview.formulaHint': '指标计算说明',
  'overview.focusAssets': '重点资产',
  'overview.assetRanking': '资产排行',
  'overview.focusEmpty': '当前口径暂无重点资产数据',
  'overview.rankEmpty': '当前口径暂无排行数据',
  'overview.realizedLabel': '已实现 USD {value}',
  'overview.priceBase': '价格基准 {price} · {source}{date}',
  'overview.priceSource.market': '最新行情价',
  'overview.priceSource.trade': '最近成交价',
  'overview.priceSource.cost': '平均成本',
  'overview.returnRate': '{value}% 已实现收益率',
  'overview.rankFormula.title': '已实现收益率算法',
  'overview.rankFormula.body1': '已实现收益率 = 已实现盈亏 / 已卖出部分对应成本 × 100%',
  'overview.rankFormula.body2': '已卖出部分对应成本按卖出时点的移动平均成本累计计算，不与当前剩余持仓混算。',

  'overview.kpi.marketValue': '{label}组合总市值（USD）',
  'overview.kpi.dividends': '{label}累计分红（USD）',
  'overview.kpi.realized': '{label}已实现盈亏（USD）',
  'overview.kpi.unrealized': '{label}未实现盈亏（USD）',
  'overview.kpi.assetCount': '{label}资产数量',

  'overview.trend.title': '组合价值走势',
  'overview.trend.rangeYtd': 'YTD',
  'overview.trend.range30d': '近30天',
  'overview.trend.range90d': '近90天',
  'overview.trend.range1y': '近1年',
  'overview.trend.loading': '加载走势中...',
  'overview.trend.empty': '暂无走势数据',
  'overview.trend.loadFailed': '加载走势失败',
  'overview.trend.aria': '组合总市值走势折线图',
  'overview.trend.rangeLabel': '{start} ~ {end}',
  'overview.trend.yAxisHint': '范围：{min} ~ {max} USD',
  'overview.trend.dividendMarker': '分红 {count} 笔 · {value}',

  'overview.ranking.title': '资产收益排行',
  'overview.ranking.desc': '按已实现收益率排序',

  'overview.allocation.title': '资产分布',
  'overview.allocation.byType': '按类型',
  'overview.allocation.byCurrency': '按币种',
  'overview.allocation.empty': '暂无可用持仓分布数据',
  'overview.allocation.aria': '资产分布饼图',

  'overview.recent.title': '最近 10 笔交易',
  'overview.recent.loading': '加载交易中...',
  'overview.recent.empty': '暂无交易数据',
  'overview.recent.loadFailed': '加载交易失败',
  'overview.recent.colDate': '日期',
  'overview.recent.colType': '类型',
  'overview.recent.colAsset': '资产',
  'overview.recent.colQty': '数量',
  'overview.recent.colPrice': '单价',
  'overview.recent.colNet': '结算金额',
  'overview.recent.qty': '数量 {value}',
  'overview.recent.net': '结算 {value}',

  'assetType.EQUITY': '股票',
  'assetType.ETF': 'ETF',
  'assetType.FUND': '基金',
  'assetType.BOND': '债券',
  'assetType.STRUCTURED_PRODUCT': '结构性产品',
  'assetType.UNKNOWN': '其他',

  // ── Position filters ──
  'position.all': '全部',
  'position.current': '当前持有',
  'position.exited': '曾经持有',
  'position.status.current': '持有中',
  'position.status.exited': '已退出',
  'position.status.inactive': '未持有',

  // ── Summary cards ──
  'summary.current.detail': '市值 USD {mv} · 未实现 {unrealized}',
  'summary.exited.detail': '已实现 {realized} · 分红 {dividend}',
  'summary.all.detail': '持有中 {current} · 已退出 {exited}',

  // ── Workspace ──
  'workspace.title': '组合工作台',
  'workspace.exportCsv': '导出 CSV',
  'workspace.resultCount': '{label} {count} 个结果资产',
  'workspace.quickRange': '先选时间范围',
  'workspace.all': '全部',
  'workspace.recent30': '近30天',
  'workspace.resultFilter': '再看范围内资产',
  'workspace.filterPlaceholder': '筛选该时间范围内的资产：名称 / 代码 / 币种',
  'workspace.clear': '清空',
  'workspace.rangeHint': '{start} ~ {end}',
  'workspace.totalReturn': '区间总收益（USD） {value}',
  'workspace.formulaAria': '区间总收益计算公式',
  'workspace.dividend': '区间分红',
  'workspace.realized': '区间已实现',
  'workspace.interestAll': '贷款利息支出',
  'workspace.interestScoped': '贷款利息支出（按资产归集）',
  'workspace.totalReturnLabel': '区间总收益',
  'workspace.viewCalc': '查看计算过程',
  'workspace.buy': '区间买入',
  'workspace.sell': '区间卖出',
  'workspace.interest': '贷款利息支出',
  'workspace.interestScopedShort': '贷款利息支出（按资产归集）',
  'workspace.currentMv': '当前市值 USD {value}',
  'workspace.unrealized': '未实现 {value}',
  'workspace.viewDetails': '查看 {count} 笔明细',
  'workspace.scopeChip': '{label} {count} 个资产',
  'workspace.interestChipAll': '全组合口径',
  'workspace.interestChipScoped': '已归属 {count} 笔利息',
  'workspace.interestUnassigned': '未分配 {count} 笔 · USD {value}',
  'workspace.hintAll': '区间卖出表示卖出回笼金额；区间已实现仅统计区间内卖出实现损益，不包含区间分红，也不扣减贷款利息。表格中的未实现盈亏按当前持仓最新市值减当前持仓成本计算。',
  'workspace.hintScoped': '当前按"{label}"口径汇总区间买入、卖出、分红、已实现与未实现指标；贷款利息未按资产状态分摊，因此当前筛选下不扣减贷款利息。',
  'workspace.metricLabel': '{label}（USD）',
  'workspace.noBreakdown': '暂无对应币种明细',
  'workspace.listHeader': '{label}范围内资产',
  'workspace.pageInfo': '第 {page} / {total} 页 · 共 {count} 个产品',
  'workspace.prevPage': '上一页',
  'workspace.nextPage': '下一页',
  'workspace.empty': '该时间范围内暂无资产事件，请重新选择月份或日期范围',
  'workspace.cardMv': '当前市值 USD',
  'workspace.cardBuy': '区间买入 USD',
  'workspace.cardSell': '区间卖出 USD',
  'workspace.cardDividend': '区间分红 USD',
  'workspace.cardRealized': '区间已实现 USD',
  'workspace.cardUnrealized': '未实现盈亏',
  'workspace.cardViewLifecycle': '查看生命周期',
  'workspace.annualized': '年化 {value}',

  // ── Workspace table columns ──
  'col.name': '名称',
  'col.currency': '币种',
  'col.mvUsd': '当前市值 USD',
  'col.buyUsd': '区间买入 USD',
  'col.sellUsd': '区间卖出 USD',
  'col.dividendUsd': '区间分红 USD',
  'col.realizedUsd': '区间已实现 USD',
  'col.unrealized': '未实现盈亏',

  // ── Monitor ──
  'monitor.title': '系统监控',
  'monitor.refresh': '刷新状态',
  'monitor.runtime': 'Runtime',
  'monitor.runtimeDesc': '后端健康检查、模型可达性与核心服务状态。',
  'monitor.waitingBackend': '等待后端启动',
  'monitor.waitingBackendShort': '等待后端',
  'monitor.portfolioSnapshot': 'Portfolio Snapshot',
  'monitor.portfolioDesc': '当前资产主档数量，随 Dashboard 刷新同步。',
  'monitor.pdfCount': '{count} 个 PDF',
  'monitor.noAsset': '未选择分析资产',
  'monitor.serviceMatrix': '服务矩阵',
  'monitor.apiStatus': 'API 状态',
  'monitor.fastModel': '快速模型',
  'monitor.fastModelDesc': '常规问答 / 解释生成',
  'monitor.thinkingModel': '思考模型',
  'monitor.thinkingModelDesc': '复杂推理 / SQL 规划',
  'monitor.talkerStatus': '智能问答接入状态',
  'monitor.talkerConnected': 'Investment-Talker v1 已接通',
  'monitor.talkerDesc': '当前支持连续对话、权威指标优先、高频模板 SQL、结果表格与逐字输出。',
  'monitor.dialogMode': '对话模式',
  'monitor.thinkingMode': '思考模式',
  'monitor.fastMode': '快速模式',
  'monitor.positioning': '当前定位',
  'monitor.positioningValue': '知识解释 / 数据问答',
  'monitor.outputChain': '输出链路',
  'monitor.outputChainValue': '答案 + 表格',
  'monitor.entryPoint': '调用入口',
  'monitor.entryPointValue': '/api/talker/chat',
  'monitor.learning': '语义学习与审核',
  'monitor.pendingBadCases': '待处理坏例',
  'monitor.activeSamples': '已启用样本',
  'monitor.semanticCandidates': '语义候选',
  'monitor.semanticCandidatesDesc': '这里是需要你确认的规则候选。你可以批准成正式规则、样本，或者直接忽略。',
  'monitor.approveRule': '批准为规则',
  'monitor.approveRuleHelp': '写入语义规则库，后续按固定语义解释优先命中。',
  'monitor.approveSample': '批准为样本',
  'monitor.approveSampleHelp': '写入 few-shot 样本库，供 Planner / Vanna / LLM 参考。',
  'monitor.ignore': '忽略',
  'monitor.ignoreHelp': '这条候选不采用，从待审核列表移除。',
  'monitor.unnamedCandidate': '未命名候选',
  'monitor.undefinedPattern': '未定义模式',
  'monitor.noCandidateDesc': '暂无候选说明',
  'monitor.approvedRule': '已批准为语义规则',
  'monitor.approvedFewshot': '已批准为 few-shot 样本',
  'monitor.ignoredSemantic': '已忽略语义候选',
  'monitor.noSemanticCandidates': '当前暂无语义候选',
  'monitor.recentBadCases': '最近坏例',
  'monitor.recentBadCasesDesc': '这里是自动沉淀的失败问答或生成异常。当前你可以先忽略无效坏例。',
  'monitor.noOriginalQuestion': '未记录原问题',
  'monitor.noFailureDetail': '暂无失败详情',
  'monitor.ignoredBadCase': '已忽略 bad case',
  'monitor.noBadCases': '当前暂无待处理坏例',
  'monitor.activeFewshots': '已启用 Few-shots',
  'monitor.activeFewshotsDesc': '当前已注入 Planner / Vanna / LLM SQL 生成上下文的 few-shot 样本。',
  'monitor.unnamedSample': '未命名样本',
  'monitor.untagged': '未打标签',
  'monitor.noSampleDesc': '暂无说明',
  'monitor.noActiveSamples': '当前暂无已启用样本',

  // ── Configure ──
  'configure.kicker': 'Configure',
  'configure.title': 'Configure',
  'configure.desc': '管理用户、功能开关与数据库设置。',
  'configure.users.kicker': '用户管理',
  'configure.users.title': '用户管理',
  'configure.users.refresh': '刷新用户列表',
  'configure.users.createUser': '新增用户',
  'configure.users.username': '用户名',
  'configure.users.usernamePlaceholder': '例如 analyst01',
  'configure.users.password': '密码',
  'configure.users.passwordPlaceholder': '至少 8 位',
  'configure.users.role': '角色',
  'configure.users.roleUser': '普通用户',
  'configure.users.roleAdmin': '管理员',
  'configure.users.create': '创建用户',
  'configure.users.creating': '创建中...',
  'configure.users.userList': '现有用户',
  'configure.users.colId': 'ID',
  'configure.users.colUsername': '用户名',
  'configure.users.colRole': '角色',
  'configure.users.colStatus': '状态',
  'configure.users.colCreatedAt': '创建时间',
  'configure.users.colResetPassword': '重置密码',
  'configure.users.active': '启用',
  'configure.users.inactive': '停用',
  'configure.users.resetPlaceholder': '输入新密码',
  'configure.users.reset': '重置',
  'configure.users.resetting': '提交中...',
  'configure.users.noData': '暂无用户数据',
  'configure.users.enterNewCredentials': '请输入新用户名和密码',
  'configure.users.createFailed': '创建用户失败',
  'configure.users.createSuccess': '用户创建成功',
  'configure.users.enterNewPassword': '请输入新密码',
  'configure.users.resetFailed': '重置密码失败',
  'configure.users.resetSuccess': '密码重置成功',
  'configure.features.kicker': '功能开关',
  'configure.features.talkerAccess': 'Talker 模块',
  'configure.features.talkerAccessDesc': '控制 Talker 是否对所有已登录用户显示和可用。默认暂时关闭。',
  'configure.features.talkerAvailable': '已启用',
  'configure.features.talkerUnavailable': '暂不启用',
  'configure.features.talkerVisibleHint': '导航中显示 Talker，用户可进入使用。',
  'configure.features.talkerHiddenHint': '导航中隐藏 Talker，接口也会拒绝访问。',
  'configure.features.talkerEnabled': 'Talker 已启用',
  'configure.features.talkerDisabled': 'Talker 已关闭',
  'configure.features.talkerUpdateFailed': 'Talker 设置更新失败',
  'configure.features.previewRedactionAvailable': '已启用',
  'configure.features.previewRedactionUnavailable': '已关闭',
  'configure.features.previewRedactionVisibleHint': '预览 PDF 时对敏感区域进行涂黑遮罩，保护隐私信息。',
  'configure.features.previewRedactionHiddenHint': '预览 PDF 时不做涂黑，直接显示原始内容。',
  'configure.features.previewRedactionEnabled': '预览涂黑已启用',
  'configure.features.previewRedactionDisabled': '预览涂黑已关闭',
  'configure.features.previewRedactionUpdateFailed': '预览涂黑设置更新失败',
  'configure.features.privacyKicker': '隐私保护',
  'configure.features.privacyTitle': '隐私保护',
  'configure.features.privacyDesc': '控制 PDF 预览时是否对敏感区域进行涂黑遮罩。',
  'configure.features.dbManagementAvailable': '已启用',
  'configure.features.dbManagementUnavailable': '已关闭',
  'configure.features.dbManagementVisibleHint': '数据库管理功能可用，可执行初始化、备份、模拟数据操作。',
  'configure.features.dbManagementHiddenHint': '数据库管理功能已关闭，所有操作按钮不可用。',
  'configure.features.dbManagementEnabled': '数据库管理已启用',
  'configure.features.dbManagementDisabled': '数据库管理已关闭',
  'configure.features.dbManagementUpdateFailed': '数据库管理设置更新失败',
  'configure.db.kicker': '数据库设置',
  'configure.db.title': '数据库管理',
  'configure.db.desc': '初始化数据库、备份数据库、生成模拟数据。',
  'configure.db.initTitle': '初始化数据库',
  'configure.db.initDesc': '清空所有资产相关数据（交易、分红、融资、文档等），保留 asset_master 资产主表。',
  'configure.db.initBtn': '初始化',
  'configure.db.initWarning': '此操作将清空所有交易、分红、转换、融资事件、外币交易、结构性产品事件、文档及行情缓存等数据，仅保留 asset_master 资产主表。操作不可撤销！',
  'configure.db.simulateWarning': '此操作将根据现有资产生成模拟交易和事件数据，可能覆盖或混淆现有数据。操作不可撤销！',
  'configure.db.backupReminder': '⚠️ 此操作具有破坏性，建议先点击「备份下载」保存当前数据库。',
  'configure.db.confirmCancel': '取消',
  'configure.db.backupTitle': '备份数据库',
  'configure.db.backupDesc': '将当前数据库导出为 .db 文件并下载。',
  'configure.db.backupBtn': '备份下载',
  'configure.db.backupDownloaded': '数据库备份已下载',
  'configure.db.backupFailed': '数据库备份失败',
  'configure.db.simulateTitle': '生成模拟数据',
  'configure.db.simulateDesc': '根据现有资产随机生成模拟交易和分红记录，用于测试系统功能。',
  'configure.db.simulateBtn': '生成模拟数据',
  'configure.db.processing': '处理中...',
  'configure.db.actionSuccess': '操作成功完成',
  'configure.db.actionFailed': '操作失败',

  // ── Security / Master Key ──
  'configure.security.kicker': '安全设置',
  'configure.security.title': '主密钥管理',
  'configure.security.desc': '修改主密钥将重新加密数据库和所有已加密的 PDF 文件。请确保记住新密钥，丢失后无法恢复数据。',
  'configure.security.oldKey': '当前主密钥',
  'configure.security.oldKeyPlaceholder': '请输入当前主密钥',
  'configure.security.newKey': '新主密钥',
  'configure.security.newKeyPlaceholder': '请输入新主密钥（至少6位）',
  'configure.security.confirmKey': '确认新主密钥',
  'configure.security.confirmKeyPlaceholder': '请再次输入新主密钥',
  'configure.security.changeBtn': '修改主密钥',
  'configure.security.processing': '加密处理中...',
  'configure.security.success': '主密钥修改成功',
  'configure.security.failed': '主密钥修改失败',
  'configure.security.mismatch': '两次输入的新密钥不一致',
  'configure.security.tooShort': '新密钥至少需要6个字符',
  'configure.security.warning': '⚠️ 此操作将重新加密整个数据库和所有 PDF 文件，可能需要较长时间。请先备份数据库。',

  // ── Talker ──
  'talker.title': '智能问答系统',
  'talker.modeAria': 'Talker 模式切换',
  'talker.fastMode': '快速模式',
  'talker.thinkingMode': '思考模式',
  'talker.hint': '当前适合：指标解释、分析思路、查询口径、报表问答',
  'talker.you': '你',
  'talker.assistant': 'Investment-Talker',
  'talker.queryResult': '查询结果',
  'talker.noData': '未查到匹配数据',
  'talker.thinking': 'Investment-Talker 正在思考中...',
  'talker.placeholder': '例如：帮我设计一个"今年分红最高资产"的安全查询口径，或者解释已实现盈亏和未实现盈亏的区别。',
  'talker.clear': '清空对话',
  'talker.send': '发送',
  'talker.sending': '发送中...',
  'talker.greeting': '你好，我是 Investment-Talker。当前已支持模型问答；当问题涉及系统已有权威指标口径时，我会优先复用系统计算逻辑，而不是自己猜 SQL。',
  'talker.requestFailed': 'Investment-Talker 请求失败',
  'talker.noAnswer': '未返回有效回答。',
  'talker.requestError': '请求失败：{error}',

  // ── Documents ──
  'docs.title': '文件处理中心',
  'docs.desc': '建议按 OCR 识别出的业务日期归档；若 OCR 尚未识别出日期，再回退到文件修改时间。',
  'docs.startExtraction': '开始解析',
  'docs.extracting': '解析中...',
  'docs.queuing': '排队中...',
  'docs.selectPdf': '选择一个或多个 PDF 文件',
  'docs.selectedFiles': '已选文件',
  'docs.pdfFiles': 'PDF 文件',
  'docs.failedPages': '失败页数',
  'docs.recentFailure': '最近失败',
  'docs.currentSelection': '当前待处理文件',
  'docs.reviewHint': '建议先确认每个文件的脱敏标注状态，未标注的文件解析归档后请及时补充标注，避免敏感信息外泄。',
  'docs.preview': '预览',
  'docs.remove': '移除',
  'docs.fileLibrary': '已归档文件',
  'docs.expand': '展开',
  'docs.collapse': '收起',
  'docs.count': '{count} 份',
  'docs.dateUnidentified': '待识别日期',
  'docs.delete': '删除',
  'docs.empty': '数据库里还没有已归档 PDF。先执行一次解析后，这里会按年 / 月显示可追溯文件树。',
  'docs.redaction.checking': '检查标注状态…',
  'docs.redaction.annotated': '已标注 {count} 处',
  'docs.redaction.notAnnotated': '尚未标注 · 去标注',
  'docs.redaction.parseFirst': '解析后可标注',
  'docs.result.title': '本次处理结果',
  'docs.result.partialFail': '部分文件处理失败，请查看下方失败信息。',
  'docs.result.allDone': '本次文件处理已全部完成。',
  'docs.result.close': '关闭',
  'docs.result.successFiles': '成功文件',
  'docs.result.failedFiles': '失败文件',
  'docs.result.successPages': '成功页数',
  'docs.result.failedPages': '失败页数',
  'docs.result.noSuccess': '暂无成功文件',
  'docs.result.noFailure': '暂无失败文件',
  'docs.result.duplicateFiles': '重复文件',
  'docs.result.duplicatePages': '重复页数',
  'docs.result.duplicateSkipped': '重复记录已跳过',
  'docs.result.noDuplicate': '暂无重复记录',
  'docs.selectFirst': '请先选择 PDF 文件',
  'docs.submitting': '正在提交解析请求...',
  'docs.submitFailed': '提交解析请求失败',
  'docs.queued': '已加入解析队列，正在后台执行...',
  'docs.statusFailed': '任务状态查询失败',
  'docs.polling': '排隊处理中（已完成 {done}/{total} 页）',
  'docs.parseFailed': '解析失败：{error}',
  'docs.pollTimeout': '任务状态查询超时，请到文档管理中查看结果',
  'docs.selected': '已选择 {count} 个 PDF 文件{dedup}',
  'docs.dedup': '，重复文件已自动忽略',
  'docs.annotateFirst': '请先点击"开始解析"完成归档后再标注该文件',
  'docs.deleteSuccess': '已删除归档文件：{name}',
  'docs.deleteFailed': '删除失败',

  // ── Analytics ──
  'analytics.assetList': '资产列表',
  'analytics.searchPlaceholder': '搜索名称 / 代码 / 币种',
  'analytics.railMeta': '{label} {count} 项',
  'analytics.railPage': '第 {page} / {total} 页 · 当前筛选 {count} 项',
  'analytics.noMatch': '没有匹配的资产，请调整搜索条件',
  'analytics.backToList': '返回资产列表',
  'analytics.lifecycle': '{name} 生命周期',
  'analytics.editMaster': '编辑主档',
  'analytics.saveMaster': '保存主档',
  'analytics.saving': '保存中...',
  'analytics.cancel': '取消',
  'analytics.eventCount': '{count} 条事件',
  'analytics.latestPrice': '最新价 {price}{date}',
  'analytics.unrealizedProfit': '未实现盈亏',
  'analytics.realizedProfit': '已实现盈亏',
  'analytics.currentPosition': '当前持仓',
  'analytics.avgCost': '均本 {value}',
  'analytics.dividendOrCost': '累计分红 / 贷款成本',
  'analytics.dividend': '累计分红',
  'analytics.interestCost': '利息 {value}',
  'analytics.loanInterest': '贷款利息 {value}',
  'analytics.assetInfo': '资产信息',
  'analytics.assetNo': '资产代码',
  'analytics.stockTicker': '股票代码',
  'analytics.assetName': '资产名称',
  'analytics.currencyType': '币种 / 类型',
  'analytics.firstBuyDate': '首次买入日',
  'analytics.firstHoldingDate': '首次持有日',
  'analytics.dividendDate': '派息日',
  'analytics.totalBuy': '累计买入',
  'analytics.totalSell': '累计卖出',
  'analytics.latestStockPrice': '最新股价',
  'analytics.priceDate': '价格日期 {date}',
  'analytics.noPriceDate': '暂无价格日期',
  'analytics.selectAsset': '请选择左侧资产查看生命周期、派息记录与来源 PDF。',

  // ── Analytics panels ──
  'panel.linked.title': '融资与换汇关联',
  'panel.linked.count': '{count} 条关联',
  'panel.lifecycle.title': '生命周期流水',
  'panel.terms.title': '产品条款',
  'panel.terms.pages': '{count} 页条款',
  'panel.linked.tab.all': '全部',
  'panel.linked.tab.allSub': '{count} 条关联',
  'panel.linked.tab.financing': '贷款摘要',
  'panel.linked.tab.structured': '结构性事件',
  'panel.linked.tab.fx': 'FX',
  'panel.linked.tab.empty': '暂无',
  'panel.linked.tab.since': '{date} 起',
  'panel.linked.empty': '当前筛选下暂无关联事件',

  // ── Linked events table ──
  'linked.businessDay': '业务日',
  'linked.type': '类型',
  'linked.amount': '金额',
  'linked.interestOrIn': '利息/换入',
  'linked.settleDate': '起息/结算日',
  'linked.rateOrFx': '利率/汇率',
  'linked.note': '说明',
  'linked.manualLink': '手动关联',
  'linked.pdf': 'PDF',
  'linked.selectAsset': '选择资产',
  'linked.saveLink': '保存关联',
  'linked.saving': '保存中',
  'linked.viewPdf': '查看PDF',
  'linked.viewPdfPage': '查看 P{page}',
  'linked.financing': '贷款摘要',
  'linked.structured': '结构性事件',
  'linked.interestLabel': '利息 {currency} {amount}',
  'linked.settleLabel': '结算 {currency} {amount}',
  'linked.buyLabel': '买入 {currency} {amount}',
  'linked.selectTarget': '请先选择要关联的目标资产',
  'linked.saveFailed': '融资关联保存失败',
  'linked.saveSuccess': '已将融资 {ref} 关联到 {asset}',
  'linked.reviewFailed': '审核操作失败',
  'linked.reviewSuccess': '操作成功',

  // ── Lifecycle table ──
  'lifecycle.businessDay': '业务日',
  'lifecycle.type': '类型',
  'lifecycle.quantity': '数量',
  'lifecycle.price': '价格',
  'lifecycle.amount': '金额',
  'lifecycle.runningQty': '累计持仓',
  'lifecycle.pdf': 'PDF',
  'lifecycle.empty': '当前资产暂无真实流水数据',
  'lifecycle.viewPdf': '查看PDF',
  'lifecycle.viewPdfPage': '查看 P{page}',
  'lifecycle.conversionOut': '转换转出',
  'lifecycle.conversionIn': '转换转入',
  'lifecycle.termination': '提前终止',

  // ── Term sheet ──
  'terms.productName': '产品全称',
  'terms.trancheCode': 'Tranche Code',
  'terms.tradeDate': 'Trade Date',
  'terms.startDate': 'Start Date',
  'terms.maturityDate': 'Maturity Date',
  'terms.fixedCouponRate': 'Fixed Coupon Rate',
  'terms.pageLabel': '第 {page} 页 / 共 {total} 页',
  'terms.sectionCount': '{count} 个段落',
  'terms.noText': '（本页未识别到条款文本）',
  'terms.noPdf': '暂未导入该产品的条款说明书 PDF。',

  // ── PDF modal ──
  'pdf.sourcePage': '来源页码：P{page}',
  'pdf.preview': 'PDF 预览',
  'pdf.loading': '加载中...',
  'pdf.backToPreview': '返回预览',
  'pdf.annotate': '标注脱敏',
  'pdf.viewOriginal': '查看原PDF',
  'pdf.redactionPreview': '脱敏预览',
  'pdf.close': '关闭',
  'pdf.pagePreview': 'PDF页预览',
  'pdf.previewFailed': 'PDF预览失败',
  'pdf.notLoggedIn': '未登录或登录已过期',
  'pdf.pagePreviewFailed': 'PDF 页面预览失败',
  'pdf.redactionLoadFailed': '脱敏规则加载失败',
  'pdf.redactionAnnotateFailed': '脱敏标注加载失败',
  'pdf.onlyArchived': '仅已归档 PDF 支持脱敏标注',
  'pdf.page': '第 {page} 页',
  'pdf.redactionLearning': '脱敏学习',
  'pdf.redactionProfile': '脱敏学习',
  'pdf.redactionThreshold': '当前文件类型达到 {count} 次后，会自动应用相同区域。',
  'pdf.regionLabel': '区域标签',
  'pdf.labelPlaceholder': '例如：name_address',
  'pdf.dragHint': '在左侧图片上拖拽即可新增脱敏框。',
  'pdf.pendingBoxes': '待保存框',
  'pdf.savedRules': '已保存规则（可删除）',
  'pdf.boxAuto': '{label} · 自动',
  'pdf.boxLearning': '{label} · 学习中({count})',
  'pdf.boxPending': '{label} · 待保存',
  'pdf.save': '保存',
  'pdf.savingBox': '保存中',
  'pdf.removeBox': '移除',
  'pdf.noPendingBoxes': '暂无待保存框，拖拽左侧图片创建。',
  'pdf.deleteRule': '删除',
  'pdf.deleting': '删除中',
  'pdf.ruleUsage': 'P{page} · x {x} / y {y} / w {w} / h {h} · 使用{count}次',
  'pdf.noSavedRules': '当前页暂无已保存规则。',

  // ── Interest detail drawer ──
  'drawer.title': '贷款利息支出明细',
  'drawer.hintAll': '当前区间共 {count} 笔，已按全组合纳入区间总收益计算。',
  'drawer.hintScoped': '当前口径已归属 {matched} 笔，另有 {unassigned} 笔未分配。',
  'drawer.close': '关闭',
  'drawer.businessDay': '业务日',
  'drawer.financingNo': '融资编号',
  'drawer.stage': '阶段',
  'drawer.interest': '利息',
  'drawer.linkedAsset': '关联资产',
  'drawer.pdf': 'PDF',
  'drawer.unassigned': '未分配',
  'drawer.empty': '当前区间暂无贷款利息支出明细',

  // ── Extraction failures ──
  'failure.duplicateFile': '重复文件',
  'failure.duplicateRecord': '重复记录',
  'failure.pdfToImage': 'PDF 转图片失败',
  'failure.filePrepare': '文件准备失败',
  'failure.dbWrite': '写库失败',
  'failure.persistenceSkip': '入库前校验未通过',
  'failure.duplicateUploaded': '重复上传，系统已跳过',
  'failure.missingConversionOut': '缺少转换转出资产编号',
  'failure.missingConversionIn': '缺少转换转入资产编号',
  'failure.missingAssetNo': '缺少资产编号',
  'failure.processFailed': '处理失败',
  'failure.pageLabel': '第 {page} 页',

  // ── File period labels ──
  'filePeriod.year': '{year}年',
  'filePeriod.month': '{month}月',
  'filePeriod.unidentified': '未识别日期',
  'filePeriod.unidentifiedYear': '未识别年份',
  'filePeriod.unidentifiedMonth': '未识别月份',
  'filePeriod.waitingOcr': '待OCR识别',

  // ── Misc ──
  'misc.assetSaveFailed': '资产主档保存失败',
  'misc.assetSaved': '资产主档已保存',
  'misc.enterAssetKeyword': '请先输入资产代码或名称',
  'misc.assetNotFound': '未找到该资产流水',
  'misc.backendError': '后端请求失败，请检查服务状态',
  'misc.healthOffline': '等待后端启动',
  'misc.noLimit': '不限',

  // ── Desktop only ──
  'desktopOnly.title': 'Desktop Only',
  'desktopOnly.default': '此功能适合在桌面端使用，请在电脑浏览器中打开。',
  'desktopOnly.monitor': '系统监控',
  'desktopOnly.users': '用户管理',
  'desktopOnly.documents': '文件导入与管理',
  'desktopOnly.documentsDesc': 'PDF 上传、批量 OCR、失败复核和文件删除适合在桌面端完成，请在电脑浏览器中打开。',

  // ── Analytics extra ──
  'analytics.clear': '清空',
  'analytics.realizedPercent': '{value}% 已实现',
  'analytics.holding': '持仓 {value}',
  'analytics.lifecycleTitle': '{name} 生命周期',
  'analytics.currentHolding': '当前持仓',
  'analytics.dividendWithCost': '累计分红 / 贷款成本',
  'analytics.interest': '利息 {value}',
  'analytics.latestPriceShort': '最新股价',
  'analytics.assetCode': '资产代码',

  // ── Panel: linked events ──
  'panel.linked.itemCount': '{count} 条',
  'panel.linked.amount': '金额',
  'panel.linked.interestOrConversion': '利息/换入',
  'panel.linked.startSettleDate': '起息/结算日',
  'panel.linked.rateOrFx': '利率/汇率',
  'panel.linked.note': '说明',
  'panel.linked.note.fx': '换汇至 {currency}',
  'panel.linked.note.financingOpen': '贷款建立 {eventDate}，起息日 {startDate}，利息支出 {currency} {amount}',
  'panel.linked.note.financingRollover': '贷款续作 {eventDate}，起息日 {startDate}，利息支出 {currency} {amount}',
  'panel.linked.note.financingMaturity': '贷款到期 {eventDate}，结算日 {startDate}，利息支出 {currency} {amount}',
  'panel.linked.manualLink': '手动关联',
  'panel.linked.pdf': 'PDF',
  'panel.linked.selectAsset': '选择资产',
  'panel.linked.saving': '保存中',
  'panel.linked.saveLink': '保存关联',
  'panel.linked.viewPdf': '查看PDF',
  'panel.linked.view': '查看',
  'panel.linked.businessDate': '业务日',
  'panel.linked.type': '类型',

  // ── Panel: lifecycle ──
  'panel.lifecycle.quantity': '数量',
  'panel.lifecycle.price': '价格',
  'panel.lifecycle.runningHolding': '累计持仓',
  'panel.lifecycle.empty': '当前资产暂无真实流水数据',

  // ── Panel: terms ──
  'panel.terms.productName': '产品全称',
  'panel.terms.pageLabel': '第 {page} 页 / 共 {total} 页',
  'panel.terms.sectionCount': '{count} 个段落',
  'panel.terms.noText': '（本页未识别到条款文本）',
  'panel.terms.noPdf': '暂未导入该产品的条款说明书 PDF。',
  'panel.terms.count': '{count} 页条款',
  'terms.visual.kicker': '结构性产品条款',
  'terms.visual.tranche': '系列：{code}',
  'terms.visual.viewPdf': '查看原始 PDF',
  'terms.visual.principal': '投资本金',
  'terms.visual.principalHint': '按已录入交易金额汇总',
  'terms.visual.coupon': '固定月票息率',
  'terms.visual.annualized': '年化约 {value}%',
  'terms.visual.tenor': '产品期限',
  'terms.visual.months': '{count} 个月',
  'terms.visual.notAvailable': '暂无条款数据',
  'terms.visual.underlyingsKicker': '挂钩标的',
  'terms.visual.underlyings': '参考股票',
  'terms.visual.initialPrice': '初始价 USD {value}',
  'terms.visual.noUnderlyings': '未识别到参考股票',
  'terms.visual.stepdownKicker': '自动赎回机制',
  'terms.visual.stepdown': '阶梯触发水平',
  'terms.visual.chartAria': '阶梯式触发水平图',
  'terms.visual.noSchedule': '未识别到触发水平明细',
  'terms.visual.triggerLegend': '触发水平（初始价格百分比）',
  'terms.visual.observationLegend': '横轴：估值日序号',
  'terms.visual.observation': '估值日 {index}',
  'terms.visual.strike': '行权价格',
  'terms.visual.knockIn': '敲入价格',
  'terms.visual.riskBuffer': '风险缓冲：距离初始价 {value}%',
  'terms.visual.riskFloor': '风险底线：距离初始价 {value}%',
  'terms.visual.strikeHint': '触发事件后的实物交割参考线。',
  'terms.visual.knockInHint': '价格跌破该线可能触发本金风险。',
  'terms.visual.timelineKicker': '关键时间轴',
  'terms.visual.timeline': '交易、起息与到期',
  'terms.visual.tradeDate': '交易日',
  'terms.visual.startDate': '起息日',
  'terms.visual.maturityDate': '到期日',
  'terms.visual.evidence': '查看 OCR 原文与 PDF 证据',
  'terms.visual.pagePdf': '预览 PDF 第 {page} 页',

  // ── PDF modal extra ──
  'pdf.annotateRedaction': '标注脱敏',
  'pdf.zoomAria': 'PDF 缩放控制',
  'pdf.zoomOut': '缩小',
  'pdf.zoomIn': '放大',
  'pdf.zoomReset': '恢复适配大小',
  'pdf.autoApplyHint': '当前文件类型达到 {threshold} 次后，会自动应用相同区域。',
  'pdf.regionLabelPlaceholder': '例如：name_address',
  'pdf.saving': '保存中',
  'pdf.remove': '移除',
  'pdf.delete': '删除',
  'pdf.ruleMeta': 'P{page} · x {x} / y {y} / w {w} / h {h} · 使用{count}次',
  'pdf.auto': '{label} · 自动',
  'pdf.learning': '{label} · 学习中({count})',
  'pdf.draft': '{label} · 待保存',

  // ── PDF redaction actions ──
  'pdf.redactionSaveFailed': '脱敏规则保存失败',
  'pdf.redactionSaved': '已保存脱敏规则，当前规则使用次数 {count}',
  'pdf.confirmDeleteRule': '确认删除脱敏规则"{label}"吗？',
  'pdf.redactionDeleteFailed': '脱敏规则删除失败',
  'pdf.redactionDeleted': '已删除脱敏规则',

  // ── Docs extra ──
  'docs.confirmDelete': '确认删除归档文件"{name}"吗？',

  // ── Interest detail drawer (extra keys) ──
  'interest.title': '贷款利息支出明细',
  'interest.hintAll': '当前区间共 {count} 笔，已按全组合纳入区间总收益计算。',
  'interest.hintScoped': '当前口径已归属 {matched} 笔，另有 {unassigned} 笔未分配。',
  'interest.financingNo': '融资编号',
  'interest.stage': '阶段',
  'interest.interest': '利息',
  'interest.linkedAsset': '关联资产',
  'interest.unassigned': '未分配',
  'interest.empty': '当前区间暂无贷款利息支出明细',

  // ── Language toggle ──
  'lang.toggle.zh': '中文',
  'lang.toggle.en': 'EN',
  'lang.aria': '语言切换',
};

export const en = {
  // ── Brand & Topbar ──
  'brand.tag': 'IIT TERMINAL',
  'brand.title': 'Investment Intelligence Tracker',
  'brand.subtitle': 'Professional multi-asset intelligence workspace for OCR-ledger analytics',
  'theme.aria': 'Theme selection',
  'theme.default': 'Default Dark',
  'theme.bloomberg': 'Bloomberg',
  'theme.coolGray': 'Cool Gray',
  'account.signOut': 'Sign Out',
  'account.admin': 'Administrator',
  'account.user': 'User',

  // ── Nav tabs (desktop) ──
  'nav.overview': 'Overview',
  'nav.documents': 'Documents',
  'nav.workspace': 'Workspace',
  'nav.analytics': 'Analytics',
  'nav.talker': 'Talker',
  'nav.monitor': 'Monitor',
  'nav.configure': 'Configure',

  // ── Nav tabs (mobile) ──
  'nav.mobile.overview': 'Overview',
  'nav.mobile.workspace': 'Workspace',
  'nav.mobile.analytics': 'Analytics',
  'nav.mobile.talker': 'Talker',

  // ── Auth ──
  'auth.checking': 'Checking authentication status',
  'auth.title': 'Sign In',
  'auth.hint': 'Please sign in to access Investment Intelligence Tracker.',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.usernamePlaceholder': 'Enter username',
  'auth.passwordPlaceholder': 'Enter password',
  'auth.login': 'Sign In',
  'auth.loggingIn': 'Signing in...',
  'auth.enterCredentials': 'Please enter username and password',
  'auth.loginFailed': 'Sign in failed',
  'auth.welcomeBack': 'Welcome back, {name}',

  // ── Security / Encryption ──
  'security.checking': 'Checking encryption status',
  'security.title': 'System Unlock',
  'security.hint': 'Storage encryption is enabled. Please enter the master key to unlock.',
  'security.warning': 'This key encrypts all asset data. Keep it safe — losing it means data cannot be recovered.',
  'security.masterKey': 'Master Key',
  'security.keyPlaceholder': 'Enter master key',
  'security.unlock': 'Unlock System',
  'security.unlocking': 'Unlocking...',
  'security.unlocked': 'System unlocked successfully',
  'security.migrated': 'Master key accepted. Database will be encrypted on next access.',
  'security.unlockFailed': 'Unlock failed',
  'security.enterKey': 'Please enter the master key',
  'security.logout': 'Sign Out',

  // ── Overview ──
  'overview.marketPulse': 'Market Pulse',
  'overview.pulseHint.fx': 'Compared to previous available trading day at latest FX rate',
  'overview.pulseHint.normal': 'Compared to last two available trading day closes',
  'overview.marketValue': '{label} Market Value (USD)',
  'overview.dividend': '{label} Cumulative Dividend (USD)',
  'overview.realizedProfit': '{label} Realized P&L (USD)',
  'overview.interest': '{label} Period Loan Interest (USD)',
  'overview.marketValueHint': 'Showing by "{label}" scope',
  'overview.dividendHint': 'Only "{label}" assets cumulative dividend',
  'overview.realizedHint': 'Only "{label}" assets sell realized P&L',
  'overview.interestHintAll': 'Aggregated portfolio loan interest for current period',
  'overview.interestHintPartial': '{matched} matched, {unassigned} unassigned',
  'overview.interestHintScoped': 'By current period + "{label}" assets',
  'overview.formula.marketValue.title': 'Portfolio Market Value (USD)',
  'overview.formula.marketValue.body': 'Portfolio Market Value (USD) = Σ(current quantity × estimated price × current FX rate to USD), sold portions excluded.',
  'overview.formula.dividend.title': 'Cumulative Dividend / Realized P&L (USD)',
  'overview.formula.dividend.body': 'Cumulative dividend and realized P&L are tracked separately; realized P&L only comes from sell trades, excludes dividends, both converted to USD at current FX snapshot.',
  'overview.formulaHint': 'Metric Calculation Notes',
  'overview.focusAssets': 'Focus Assets',
  'overview.assetRanking': 'Asset Ranking',
  'overview.focusEmpty': 'No focus assets for current scope',
  'overview.rankEmpty': 'No ranking data for current scope',
  'overview.realizedLabel': 'Realized USD {value}',
  'overview.priceBase': 'Price {price} · {source}{date}',
  'overview.priceSource.market': 'Market Quote',
  'overview.priceSource.trade': 'Last Trade',
  'overview.priceSource.cost': 'Avg Cost',
  'overview.returnRate': '{value}% Realized Return',
  'overview.rankFormula.title': 'Realized Return Algorithm',
  'overview.rankFormula.body1': 'Realized Return = Realized P&L / Cost of Sold Portion × 100%',
  'overview.rankFormula.body2': 'Cost of sold portion is accumulated using moving average cost at sell time, not mixed with remaining holdings.',

  'overview.kpi.marketValue': '{label} Total Market Value (USD)',
  'overview.kpi.dividends': '{label} Cumulative Dividends (USD)',
  'overview.kpi.realized': '{label} Realized P&L (USD)',
  'overview.kpi.unrealized': '{label} Unrealized P&L (USD)',
  'overview.kpi.assetCount': '{label} Asset Count',

  'overview.trend.title': 'Portfolio Value Trend',
  'overview.trend.rangeYtd': 'YTD',
  'overview.trend.range30d': '30D',
  'overview.trend.range90d': '90D',
  'overview.trend.range1y': '1Y',
  'overview.trend.loading': 'Loading trend...',
  'overview.trend.empty': 'No trend data available',
  'overview.trend.loadFailed': 'Failed to load trend',
  'overview.trend.aria': 'Portfolio market value trend line chart',
  'overview.trend.rangeLabel': '{start} ~ {end}',
  'overview.trend.yAxisHint': 'Range: {min} ~ {max} USD',
  'overview.trend.dividendMarker': 'Dividends {count} · {value}',

  'overview.ranking.title': 'Asset Ranking',
  'overview.ranking.desc': 'Sorted by realized return rate',

  'overview.allocation.title': 'Allocation',
  'overview.allocation.byType': 'By Type',
  'overview.allocation.byCurrency': 'By Currency',
  'overview.allocation.empty': 'No allocation data available',
  'overview.allocation.aria': 'Asset allocation pie chart',

  'overview.recent.title': 'Recent 10 Transactions',
  'overview.recent.loading': 'Loading transactions...',
  'overview.recent.empty': 'No transaction data',
  'overview.recent.loadFailed': 'Failed to load transactions',
  'overview.recent.colDate': 'Date',
  'overview.recent.colType': 'Type',
  'overview.recent.colAsset': 'Asset',
  'overview.recent.colQty': 'Quantity',
  'overview.recent.colPrice': 'Price',
  'overview.recent.colNet': 'Net Amount',
  'overview.recent.qty': 'Qty {value}',
  'overview.recent.net': 'Net {value}',

  'assetType.EQUITY': 'Stock',
  'assetType.ETF': 'ETF',
  'assetType.FUND': 'Fund',
  'assetType.BOND': 'Bond',
  'assetType.STRUCTURED_PRODUCT': 'Structured Product',
  'assetType.UNKNOWN': 'Other',

  // ── Position filters ──
  'position.all': 'All',
  'position.current': 'Current',
  'position.exited': 'Exited',
  'position.status.current': 'Holding',
  'position.status.exited': 'Exited',
  'position.status.inactive': 'Inactive',

  // ── Summary cards ──
  'summary.current.detail': 'MV USD {mv} · Unrealized {unrealized}',
  'summary.exited.detail': 'Realized {realized} · Dividend {dividend}',
  'summary.all.detail': 'Current {current} · Exited {exited}',

  // ── Workspace ──
  'workspace.title': 'Portfolio Workspace',
  'workspace.exportCsv': 'Export CSV',
  'workspace.resultCount': '{label} {count} results',
  'workspace.quickRange': 'Select Time Range',
  'workspace.all': 'All',
  'workspace.recent30': 'Last 30 Days',
  'workspace.resultFilter': 'Filter Assets in Range',
  'workspace.filterPlaceholder': 'Filter assets: name / code / currency',
  'workspace.clear': 'Clear',
  'workspace.rangeHint': '{start} ~ {end}',
  'workspace.totalReturn': 'Period Total Return (USD) {value}',
  'workspace.formulaAria': 'Period total return formula',
  'workspace.dividend': 'Period Dividend',
  'workspace.realized': 'Period Realized',
  'workspace.interestAll': 'Loan Interest Expense',
  'workspace.interestScoped': 'Loan Interest (by Asset)',
  'workspace.totalReturnLabel': 'Period Total Return',
  'workspace.viewCalc': 'View Calculation',
  'workspace.buy': 'Period Buy',
  'workspace.sell': 'Period Sell',
  'workspace.interest': 'Loan Interest Expense',
  'workspace.interestScopedShort': 'Loan Interest (by Asset)',
  'workspace.currentMv': 'Current MV USD {value}',
  'workspace.unrealized': 'Unrealized {value}',
  'workspace.viewDetails': 'View {count} details',
  'workspace.scopeChip': '{label} {count} assets',
  'workspace.interestChipAll': 'Portfolio Scope',
  'workspace.interestChipScoped': '{count} interest matched',
  'workspace.interestUnassigned': '{count} unassigned · USD {value}',
  'workspace.hintAll': 'Period sell represents sell proceeds; period realized only counts sell realized P&L within the period, excludes dividends and loan interest. Unrealized P&L in the table is calculated from current holdings at latest market value minus current holding cost.',
  'workspace.hintScoped': 'Currently aggregating period buy, sell, dividend, realized and unrealized by "{label}" scope; loan interest is not split by asset status, so it is not deducted under current filter.',
  'workspace.metricLabel': '{label} (USD)',
  'workspace.noBreakdown': 'No currency breakdown',
  'workspace.listHeader': '{label} Assets in Range',
  'workspace.pageInfo': 'Page {page} / {total} · {count} products',
  'workspace.prevPage': 'Prev',
  'workspace.nextPage': 'Next',
  'workspace.empty': 'No asset events in this time range, please select a different month or date range',
  'workspace.cardMv': 'Current MV USD',
  'workspace.cardBuy': 'Period Buy USD',
  'workspace.cardSell': 'Period Sell USD',
  'workspace.cardDividend': 'Period Dividend USD',
  'workspace.cardRealized': 'Period Realized USD',
  'workspace.cardUnrealized': 'Unrealized P&L',
  'workspace.cardViewLifecycle': 'View Lifecycle',
  'workspace.annualized': 'Annual {value}',

  // ── Workspace table columns ──
  'col.name': 'Name',
  'col.currency': 'Currency',
  'col.mvUsd': 'Current MV USD',
  'col.buyUsd': 'Period Buy USD',
  'col.sellUsd': 'Period Sell USD',
  'col.dividendUsd': 'Period Dividend USD',
  'col.realizedUsd': 'Period Realized USD',
  'col.unrealized': 'Unrealized P&L',

  // ── Monitor ──
  'monitor.title': 'System Monitor',
  'monitor.refresh': 'Refresh Status',
  'monitor.runtime': 'Runtime',
  'monitor.runtimeDesc': 'Backend health check, model availability and core service status.',
  'monitor.waitingBackend': 'Waiting for backend',
  'monitor.waitingBackendShort': 'Waiting',
  'monitor.portfolioSnapshot': 'Portfolio Snapshot',
  'monitor.portfolioDesc': 'Current asset master count, synced with Dashboard.',
  'monitor.pdfCount': '{count} PDFs',
  'monitor.noAsset': 'No analysis asset selected',
  'monitor.serviceMatrix': 'Service Matrix',
  'monitor.apiStatus': 'API Status',
  'monitor.fastModel': 'Fast Model',
  'monitor.fastModelDesc': 'Regular Q&A / explanation generation',
  'monitor.thinkingModel': 'Thinking Model',
  'monitor.thinkingModelDesc': 'Complex reasoning / SQL planning',
  'monitor.talkerStatus': 'Talker Integration Status',
  'monitor.talkerConnected': 'Investment-Talker v1 Connected',
  'monitor.talkerDesc': 'Currently supports continuous dialogue, authoritative metrics priority, high-frequency template SQL, result tables and streaming output.',
  'monitor.dialogMode': 'Dialog Mode',
  'monitor.thinkingMode': 'Thinking Mode',
  'monitor.fastMode': 'Fast Mode',
  'monitor.positioning': 'Positioning',
  'monitor.positioningValue': 'Knowledge Explanation / Data Q&A',
  'monitor.outputChain': 'Output Chain',
  'monitor.outputChainValue': 'Answer + Table',
  'monitor.entryPoint': 'Entry Point',
  'monitor.entryPointValue': '/api/talker/chat',
  'monitor.learning': 'Semantic Learning & Review',
  'monitor.pendingBadCases': 'Pending Bad Cases',
  'monitor.activeSamples': 'Active Samples',
  'monitor.semanticCandidates': 'Semantic Candidates',
  'monitor.semanticCandidatesDesc': 'These are rule candidates for your confirmation. You can approve as formal rules, samples, or ignore.',
  'monitor.approveRule': 'Approve as Rule',
  'monitor.approveRuleHelp': 'Write to semantic rule library, subsequent matches prioritized by fixed semantics.',
  'monitor.approveSample': 'Approve as Sample',
  'monitor.approveSampleHelp': 'Write to few-shot sample library for Planner / Vanna / LLM reference.',
  'monitor.ignore': 'Ignore',
  'monitor.ignoreHelp': 'This candidate is not adopted, removed from pending list.',
  'monitor.unnamedCandidate': 'Unnamed Candidate',
  'monitor.undefinedPattern': 'Undefined Pattern',
  'monitor.noCandidateDesc': 'No candidate description',
  'monitor.approvedRule': 'Approved as semantic rule',
  'monitor.approvedFewshot': 'Approved as few-shot sample',
  'monitor.ignoredSemantic': 'Ignored semantic candidate',
  'monitor.noSemanticCandidates': 'No semantic candidates',
  'monitor.recentBadCases': 'Recent Bad Cases',
  'monitor.recentBadCasesDesc': 'These are auto-captured failed Q&A or generation anomalies. You can ignore invalid bad cases for now.',
  'monitor.noOriginalQuestion': 'No original question recorded',
  'monitor.noFailureDetail': 'No failure details',
  'monitor.ignoredBadCase': 'Ignored bad case',
  'monitor.noBadCases': 'No pending bad cases',
  'monitor.activeFewshots': 'Active Few-shots',
  'monitor.activeFewshotsDesc': 'Few-shot samples currently injected into Planner / Vanna / LLM SQL generation context.',
  'monitor.unnamedSample': 'Unnamed Sample',
  'monitor.untagged': 'Untagged',
  'monitor.noSampleDesc': 'No description',
  'monitor.noActiveSamples': 'No active samples',

  // ── Configure ──
  'configure.kicker': 'System Configuration',
  'configure.title': 'Configure',
  'configure.desc': 'Manage users, feature toggles, and database settings.',
  'configure.users.kicker': 'User Management',
  'configure.users.title': 'User Management',
  'configure.users.refresh': 'Refresh User List',
  'configure.users.createUser': 'Create User',
  'configure.users.username': 'Username',
  'configure.users.usernamePlaceholder': 'e.g. analyst01',
  'configure.users.password': 'Password',
  'configure.users.passwordPlaceholder': 'At least 8 characters',
  'configure.users.role': 'Role',
  'configure.users.roleUser': 'User',
  'configure.users.roleAdmin': 'Admin',
  'configure.users.create': 'Create User',
  'configure.users.creating': 'Creating...',
  'configure.users.userList': 'User List',
  'configure.users.colId': 'ID',
  'configure.users.colUsername': 'Username',
  'configure.users.colRole': 'Role',
  'configure.users.colStatus': 'Status',
  'configure.users.colCreatedAt': 'Created At',
  'configure.users.colResetPassword': 'Reset Password',
  'configure.users.active': 'Active',
  'configure.users.inactive': 'Disabled',
  'configure.users.resetPlaceholder': 'Enter new password',
  'configure.users.reset': 'Reset',
  'configure.users.resetting': 'Submitting...',
  'configure.users.noData': 'No user data',
  'configure.users.enterNewCredentials': 'Please enter new username and password',
  'configure.users.createFailed': 'Failed to create user',
  'configure.users.createSuccess': 'User created successfully',
  'configure.users.enterNewPassword': 'Please enter new password',
  'configure.users.resetFailed': 'Failed to reset password',
  'configure.users.resetSuccess': 'Password reset successfully',
  'configure.features.kicker': 'Feature Toggles',
  'configure.features.talkerAccess': 'Talker Module',
  'configure.features.talkerAccessDesc': 'Controls whether Talker is visible and available to all signed-in users. It is off by default while the module is refined.',
  'configure.features.talkerAvailable': 'Available',
  'configure.features.talkerUnavailable': 'Unavailable',
  'configure.features.talkerVisibleHint': 'Talker is shown in navigation and can be opened by users.',
  'configure.features.talkerHiddenHint': 'Talker is hidden from navigation and its chat API rejects access.',
  'configure.features.talkerEnabled': 'Talker enabled',
  'configure.features.talkerDisabled': 'Talker disabled',
  'configure.features.talkerUpdateFailed': 'Failed to update Talker setting',
  'configure.features.previewRedactionAvailable': 'Enabled',
  'configure.features.previewRedactionUnavailable': 'Disabled',
  'configure.features.previewRedactionVisibleHint': 'Sensitive areas are blacked out when previewing PDFs to protect private information.',
  'configure.features.previewRedactionHiddenHint': 'PDF previews show original content without redaction.',
  'configure.features.previewRedactionEnabled': 'Preview redaction enabled',
  'configure.features.previewRedactionDisabled': 'Preview redaction disabled',
  'configure.features.previewRedactionUpdateFailed': 'Failed to update preview redaction setting',
  'configure.features.privacyKicker': 'Privacy Protection',
  'configure.features.privacyTitle': 'Privacy Protection',
  'configure.features.privacyDesc': 'Controls whether sensitive areas are blacked out when previewing PDFs.',
  'configure.features.dbManagementAvailable': 'Enabled',
  'configure.features.dbManagementUnavailable': 'Disabled',
  'configure.features.dbManagementVisibleHint': 'Database management is available. Init, backup, and simulate actions can be used.',
  'configure.features.dbManagementHiddenHint': 'Database management is disabled. All action buttons are unavailable.',
  'configure.features.dbManagementEnabled': 'Database management enabled',
  'configure.features.dbManagementDisabled': 'Database management disabled',
  'configure.features.dbManagementUpdateFailed': 'Failed to update database management setting',
  'configure.db.kicker': 'Database Settings',
  'configure.db.title': 'Database Management',
  'configure.db.desc': 'Initialize database, backup database, and generate mock data.',
  'configure.db.initTitle': 'Initialize Database',
  'configure.db.initDesc': 'Clear all asset-related data (transactions, dividends, financing, documents, etc.), keeping the asset_master table.',
  'configure.db.initBtn': 'Initialize',
  'configure.db.initWarning': 'This operation will clear all transactions, dividends, conversions, financing events, FX transactions, structured product events, documents, and market price caches. Only the asset_master table will be preserved. This action is irreversible!',
  'configure.db.simulateWarning': 'This operation will generate mock transactions and events based on existing assets, which may overwrite or conflict with existing data. This action is irreversible!',
  'configure.db.backupReminder': '⚠️ This operation is destructive. It is recommended to click "Download Backup" first to save the current database.',
  'configure.db.confirmCancel': 'Cancel',
  'configure.db.backupTitle': 'Backup Database',
  'configure.db.backupDesc': 'Export the current database as a .db file and download it.',
  'configure.db.backupBtn': 'Download Backup',
  'configure.db.backupDownloaded': 'Database backup downloaded',
  'configure.db.backupFailed': 'Database backup failed',
  'configure.db.simulateTitle': 'Generate Mock Data',
  'configure.db.simulateDesc': 'Generate random mock transactions and dividends based on existing assets, for testing system functionality.',
  'configure.db.simulateBtn': 'Generate Mock Data',
  'configure.db.processing': 'Processing...',
  'configure.db.actionSuccess': 'Operation completed successfully',
  'configure.db.actionFailed': 'Operation failed',

  // ── Security / Master Key ──
  'configure.security.kicker': 'Security Settings',
  'configure.security.title': 'Master Key Management',
  'configure.security.desc': 'Changing the master key will re-encrypt the database and all encrypted PDF files. Make sure to remember the new key — data cannot be recovered if lost.',
  'configure.security.oldKey': 'Current Master Key',
  'configure.security.oldKeyPlaceholder': 'Enter current master key',
  'configure.security.newKey': 'New Master Key',
  'configure.security.newKeyPlaceholder': 'Enter new master key (min 6 chars)',
  'configure.security.confirmKey': 'Confirm New Master Key',
  'configure.security.confirmKeyPlaceholder': 'Enter new master key again',
  'configure.security.changeBtn': 'Change Master Key',
  'configure.security.processing': 'Encrypting...',
  'configure.security.success': 'Master key changed successfully',
  'configure.security.failed': 'Failed to change master key',
  'configure.security.mismatch': 'New keys do not match',
  'configure.security.tooShort': 'New key must be at least 6 characters',
  'configure.security.warning': '⚠️ This operation will re-encrypt the entire database and all PDF files, which may take a while. Please backup the database first.',

  // ── Talker ──
  'talker.title': 'Investment Talker',
  'talker.modeAria': 'Talker mode switch',
  'talker.fastMode': 'Fast Mode',
  'talker.thinkingMode': 'Thinking Mode',
  'talker.hint': 'Suitable for: metric explanation, analysis ideas, query scope, report Q&A',
  'talker.you': 'You',
  'talker.assistant': 'Investment-Talker',
  'talker.queryResult': 'Query Result',
  'talker.noData': 'No matching data found',
  'talker.thinking': 'Investment-Talker is thinking...',
  'talker.placeholder': 'e.g. Design a safe query for "highest dividend asset this year", or explain the difference between realized and unrealized P&L.',
  'talker.clear': 'Clear',
  'talker.send': 'Send',
  'talker.sending': 'Sending...',
  'talker.greeting': 'Hello, I am Investment-Talker. I currently support model Q&A; when questions involve authoritative metric definitions in the system, I prioritize reusing system calculation logic rather than guessing SQL.',
  'talker.requestFailed': 'Investment-Talker request failed',
  'talker.noAnswer': 'No valid answer returned.',
  'talker.requestError': 'Request failed: {error}',

  // ── Documents ──
  'docs.title': 'Document Intake Center',
  'docs.desc': 'Archive by OCR-identified business date; fall back to file modification time if OCR has not identified a date.',
  'docs.startExtraction': 'Start Extraction',
  'docs.extracting': 'Extracting...',
  'docs.queuing': 'Queued...',
  'docs.selectPdf': 'Select one or more PDF files',
  'docs.selectedFiles': 'Selected Files',
  'docs.pdfFiles': 'PDF Files',
  'docs.failedPages': 'Failed Pages',
  'docs.recentFailure': 'Latest Failure',
  'docs.currentSelection': 'Pending Files',
  'docs.reviewHint': 'Please confirm redaction status for each file first. Unannotated files should be annotated promptly after extraction to prevent sensitive information leakage.',
  'docs.preview': 'Preview',
  'docs.remove': 'Remove',
  'docs.fileLibrary': 'Archived Files',
  'docs.expand': 'Expand',
  'docs.collapse': 'Collapse',
  'docs.count': '{count} files',
  'docs.dateUnidentified': 'Date unidentified',
  'docs.delete': 'Delete',
  'docs.empty': 'No archived PDFs yet. After extraction, a traceable file tree will appear by year / month.',
  'docs.redaction.checking': 'Checking annotation status...',
  'docs.redaction.annotated': 'Annotated {count} areas',
  'docs.redaction.notAnnotated': 'Not annotated · Annotate',
  'docs.redaction.parseFirst': 'Annotate after extraction',
  'docs.result.title': 'Processing Results',
  'docs.result.partialFail': 'Some files failed processing, see failure details below.',
  'docs.result.allDone': 'All files processed successfully.',
  'docs.result.close': 'Close',
  'docs.result.successFiles': 'Successful Files',
  'docs.result.failedFiles': 'Failed Files',
  'docs.result.successPages': 'Successful Pages',
  'docs.result.failedPages': 'Failed Pages',
  'docs.result.noSuccess': 'No successful files',
  'docs.result.noFailure': 'No failed files',
  'docs.result.duplicateFiles': 'Duplicate Files',
  'docs.result.duplicatePages': 'Duplicate Pages',
  'docs.result.duplicateSkipped': 'Duplicate records skipped',
  'docs.result.noDuplicate': 'No duplicate records',
  'docs.selectFirst': 'Please select PDF files first',
  'docs.submitting': 'Submitting extraction request...',
  'docs.submitFailed': 'Failed to submit extraction request',
  'docs.queued': 'Queued for extraction, running in background...',
  'docs.statusFailed': 'Task status query failed',
  'docs.polling': 'Processing ({done}/{total} pages done)',
  'docs.parseFailed': 'Extraction failed: {error}',
  'docs.pollTimeout': 'Task status query timed out, please check results in Document Management',
  'docs.selected': 'Selected {count} PDF files{dedup}',
  'docs.dedup': ', duplicates auto-skipped',
  'docs.annotateFirst': 'Please click "Start Extraction" to archive before annotating',
  'docs.deleteSuccess': 'Deleted archived file: {name}',
  'docs.deleteFailed': 'Delete failed',

  // ── Analytics ──
  'analytics.assetList': 'Asset List',
  'analytics.searchPlaceholder': 'Search name / code / currency',
  'analytics.railMeta': '{label} {count} items',
  'analytics.railPage': 'Page {page} / {total} · {count} filtered',
  'analytics.noMatch': 'No matching assets, please adjust search',
  'analytics.backToList': 'Back to Asset List',
  'analytics.lifecycle': '{name} Lifecycle',
  'analytics.editMaster': 'Edit Master',
  'analytics.saveMaster': 'Save Master',
  'analytics.saving': 'Saving...',
  'analytics.cancel': 'Cancel',
  'analytics.eventCount': '{count} events',
  'analytics.latestPrice': 'Latest {price}{date}',
  'analytics.unrealizedProfit': 'Unrealized P&L',
  'analytics.realizedProfit': 'Realized P&L',
  'analytics.currentPosition': 'Current Position',
  'analytics.avgCost': 'Avg Cost {value}',
  'analytics.dividendOrCost': 'Dividend / Loan Cost',
  'analytics.dividend': 'Cumulative Dividend',
  'analytics.interestCost': 'Interest {value}',
  'analytics.loanInterest': 'Loan Interest {value}',
  'analytics.assetInfo': 'Asset Info',
  'analytics.assetNo': 'Asset Code',
  'analytics.stockTicker': 'Stock Ticker',
  'analytics.assetName': 'Asset Name',
  'analytics.currencyType': 'Currency / Type',
  'analytics.firstBuyDate': 'First Buy Date',
  'analytics.firstHoldingDate': 'First Holding Date',
  'analytics.dividendDate': 'Dividend Date',
  'analytics.totalBuy': 'Total Buy',
  'analytics.totalSell': 'Total Sell',
  'analytics.latestStockPrice': 'Latest Price',
  'analytics.priceDate': 'Price Date {date}',
  'analytics.noPriceDate': 'No price date',
  'analytics.selectAsset': 'Select an asset to view lifecycle, dividend records and source PDFs.',

  // ── Analytics panels ──
  'panel.linked.title': 'Financing & FX Links',
  'panel.linked.count': '{count} links',
  'panel.lifecycle.title': 'Lifecycle Events',
  'panel.terms.title': 'Term Sheet',
  'panel.terms.pages': '{count} pages',
  'panel.linked.tab.all': 'All',
  'panel.linked.tab.allSub': '{count} links',
  'panel.linked.tab.financing': 'Financing',
  'panel.linked.tab.structured': 'Structured',
  'panel.linked.tab.fx': 'FX',
  'panel.linked.tab.empty': 'None',
  'panel.linked.tab.since': 'since {date}',
  'panel.linked.empty': 'No linked events for current filter',

  // ── Linked events table ──
  'linked.businessDay': 'Date',
  'linked.type': 'Type',
  'linked.amount': 'Amount',
  'linked.interestOrIn': 'Interest/In',
  'linked.settleDate': 'Settle Date',
  'linked.rateOrFx': 'Rate/FX',
  'linked.note': 'Note',
  'linked.manualLink': 'Manual Link',
  'linked.pdf': 'PDF',
  'linked.selectAsset': 'Select Asset',
  'linked.saveLink': 'Save Link',
  'linked.saving': 'Saving',
  'linked.viewPdf': 'View PDF',
  'linked.viewPdfPage': 'View P{page}',
  'linked.financing': 'Financing',
  'linked.structured': 'Structured',
  'linked.interestLabel': 'Interest {currency} {amount}',
  'linked.settleLabel': 'Settle {currency} {amount}',
  'linked.buyLabel': 'Buy {currency} {amount}',
  'linked.selectTarget': 'Please select target asset to link',
  'linked.saveFailed': 'Failed to save financing link',
  'linked.saveSuccess': 'Linked financing {ref} to {asset}',
  'linked.reviewFailed': 'Review action failed',
  'linked.reviewSuccess': 'Action completed',

  // ── Lifecycle table ──
  'lifecycle.businessDay': 'Date',
  'lifecycle.type': 'Type',
  'lifecycle.quantity': 'Quantity',
  'lifecycle.price': 'Price',
  'lifecycle.amount': 'Amount',
  'lifecycle.runningQty': 'Running Qty',
  'lifecycle.pdf': 'PDF',
  'lifecycle.empty': 'No transaction data for this asset',
  'lifecycle.viewPdf': 'View PDF',
  'lifecycle.viewPdfPage': 'View P{page}',
  'lifecycle.conversionOut': 'Conversion Out',
  'lifecycle.conversionIn': 'Conversion In',
  'lifecycle.termination': 'Termination',

  // ── Term sheet ──
  'terms.productName': 'Product Name',
  'terms.trancheCode': 'Tranche Code',
  'terms.tradeDate': 'Trade Date',
  'terms.startDate': 'Start Date',
  'terms.maturityDate': 'Maturity Date',
  'terms.fixedCouponRate': 'Fixed Coupon Rate',
  'terms.pageLabel': 'Page {page} / {total}',
  'terms.sectionCount': '{count} sections',
  'terms.noText': '(No term text recognized on this page)',
  'terms.noPdf': 'No term sheet PDF imported for this product.',

  // ── PDF modal ──
  'pdf.sourcePage': 'Source Page: P{page}',
  'pdf.preview': 'PDF Preview',
  'pdf.loading': 'Loading...',
  'pdf.backToPreview': 'Back to Preview',
  'pdf.annotate': 'Annotate',
  'pdf.viewOriginal': 'View Original',
  'pdf.redactionPreview': 'Redaction Preview',
  'pdf.close': 'Close',
  'pdf.pagePreview': 'PDF Page Preview',
  'pdf.previewFailed': 'PDF preview failed',
  'pdf.notLoggedIn': 'Not logged in or session expired',
  'pdf.pagePreviewFailed': 'PDF page preview failed',
  'pdf.redactionLoadFailed': 'Failed to load redaction rules',
  'pdf.redactionAnnotateFailed': 'Failed to load redaction annotation',
  'pdf.onlyArchived': 'Only archived PDFs support redaction annotation',
  'pdf.page': 'Page {page}',
  'pdf.redactionLearning': 'Redaction Learning',
  'pdf.redactionProfile': 'Redaction Learning',
  'pdf.redactionThreshold': 'After {count} occurrences for this file type, same regions will be auto-applied.',
  'pdf.regionLabel': 'Region Label',
  'pdf.labelPlaceholder': 'e.g. name_address',
  'pdf.dragHint': 'Drag on the image to add a redaction box.',
  'pdf.pendingBoxes': 'Pending Boxes',
  'pdf.savedRules': 'Saved Rules (deletable)',
  'pdf.boxAuto': '{label} · Auto',
  'pdf.boxLearning': '{label} · Learning ({count})',
  'pdf.boxPending': '{label} · Pending',
  'pdf.save': 'Save',
  'pdf.savingBox': 'Saving',
  'pdf.removeBox': 'Remove',
  'pdf.noPendingBoxes': 'No pending boxes, drag on the image to create.',
  'pdf.deleteRule': 'Delete',
  'pdf.deleting': 'Deleting',
  'pdf.ruleUsage': 'P{page} · x {x} / y {y} / w {w} / h {h} · used {count} times',
  'pdf.noSavedRules': 'No saved rules for this page.',

  // ── Interest detail drawer ──
  'drawer.title': 'Loan Interest Details',
  'drawer.hintAll': '{count} entries in current period, included in total return calculation.',
  'drawer.hintScoped': '{matched} matched, {unassigned} unassigned.',
  'drawer.close': 'Close',
  'drawer.businessDay': 'Date',
  'drawer.financingNo': 'Financing No',
  'drawer.stage': 'Stage',
  'drawer.interest': 'Interest',
  'drawer.linkedAsset': 'Linked Asset',
  'drawer.pdf': 'PDF',
  'drawer.unassigned': 'Unassigned',
  'drawer.empty': 'No loan interest details for current period',

  // ── Extraction failures ──
  'failure.duplicateFile': 'Duplicate file',
  'failure.duplicateRecord': 'Duplicate record',
  'failure.pdfToImage': 'PDF to image failed',
  'failure.filePrepare': 'File preparation failed',
  'failure.dbWrite': 'Database write failed',
  'failure.persistenceSkip': 'Pre-persistence validation failed',
  'failure.duplicateUploaded': 'Duplicate upload, skipped',
  'failure.missingConversionOut': 'Missing conversion source asset code',
  'failure.missingConversionIn': 'Missing conversion target asset code',
  'failure.missingAssetNo': 'Missing asset code',
  'failure.processFailed': 'Processing failed',
  'failure.pageLabel': 'Page {page}',

  // ── File period labels ──
  'filePeriod.year': '{year}',
  'filePeriod.month': '/{month}',
  'filePeriod.unidentified': 'Unidentified date',
  'filePeriod.unidentifiedYear': 'Unknown year',
  'filePeriod.unidentifiedMonth': 'Unknown month',
  'filePeriod.waitingOcr': 'Awaiting OCR',

  // ── Misc ──
  'misc.assetSaveFailed': 'Failed to save asset master',
  'misc.assetSaved': 'Asset master saved',
  'misc.enterAssetKeyword': 'Please enter asset code or name first',
  'misc.assetNotFound': 'Asset ledger not found',
  'misc.backendError': 'Backend request failed, please check service status',
  'misc.healthOffline': 'Waiting for backend',
  'misc.noLimit': 'Any',

  // ── Desktop only ──
  'desktopOnly.title': 'Desktop Only',
  'desktopOnly.default': 'This feature is best used on desktop. Please open in a desktop browser.',
  'desktopOnly.monitor': 'System Monitor',
  'desktopOnly.users': 'User Administration',
  'desktopOnly.documents': 'Document Intake & Management',
  'desktopOnly.documentsDesc': 'PDF upload, batch OCR, failure review and file deletion are best done on desktop. Please open in a desktop browser.',

  // ── Analytics extra ──
  'analytics.clear': 'Clear',
  'analytics.realizedPercent': '{value}% realized',
  'analytics.holding': 'Holding {value}',
  'analytics.lifecycleTitle': '{name} Lifecycle',
  'analytics.currentHolding': 'Current Holding',
  'analytics.dividendWithCost': 'Dividend / Loan Cost',
  'analytics.interest': 'Interest {value}',
  'analytics.latestPriceShort': 'Latest Price',
  'analytics.assetCode': 'Asset Code',

  // ── Panel: linked events ──
  'panel.linked.itemCount': '{count} items',
  'panel.linked.amount': 'Amount',
  'panel.linked.interestOrConversion': 'Interest/Conversion',
  'panel.linked.startSettleDate': 'Start/Settle Date',
  'panel.linked.rateOrFx': 'Rate/FX',
  'panel.linked.note': 'Note',
  'panel.linked.note.fx': 'Converted to {currency}',
  'panel.linked.note.financingOpen': 'Loan opened {eventDate}; start date {startDate}; interest expense {currency} {amount}',
  'panel.linked.note.financingRollover': 'Loan rollover {eventDate}; start date {startDate}; interest expense {currency} {amount}',
  'panel.linked.note.financingMaturity': 'Loan matures {eventDate}; settlement date {startDate}; interest expense {currency} {amount}',
  'panel.linked.manualLink': 'Manual Link',
  'panel.linked.pdf': 'PDF',
  'panel.linked.selectAsset': 'Select Asset',
  'panel.linked.saving': 'Saving',
  'panel.linked.saveLink': 'Save Link',
  'panel.linked.viewPdf': 'View PDF',
  'panel.linked.view': 'View',
  'panel.linked.businessDate': 'Date',
  'panel.linked.type': 'Type',

  // ── Panel: lifecycle ──
  'panel.lifecycle.quantity': 'Quantity',
  'panel.lifecycle.price': 'Price',
  'panel.lifecycle.runningHolding': 'Running Holding',
  'panel.lifecycle.empty': 'No lifecycle data for this asset',

  // ── Panel: terms ──
  'panel.terms.productName': 'Product Name',
  'panel.terms.pageLabel': 'Page {page} / {total}',
  'panel.terms.sectionCount': '{count} sections',
  'panel.terms.noText': '(No term text recognized on this page)',
  'panel.terms.noPdf': 'No term sheet PDF imported for this product.',
  'panel.terms.count': '{count} pages',
  'terms.visual.kicker': 'STRUCTURED PRODUCT TERMS',
  'terms.visual.tranche': 'Tranche: {code}',
  'terms.visual.viewPdf': 'View source PDF',
  'terms.visual.principal': 'Principal Amount',
  'terms.visual.principalHint': 'Based on recorded trade amount',
  'terms.visual.coupon': 'Fixed Monthly Coupon',
  'terms.visual.annualized': 'Approx. {value}% p.a.',
  'terms.visual.tenor': 'Product Tenor',
  'terms.visual.months': '{count} months',
  'terms.visual.notAvailable': 'Not available',
  'terms.visual.underlyingsKicker': 'UNDERLYING ASSETS',
  'terms.visual.underlyings': 'Reference Shares',
  'terms.visual.initialPrice': 'Initial price USD {value}',
  'terms.visual.noUnderlyings': 'No reference shares identified',
  'terms.visual.stepdownKicker': 'AUTOCALL MECHANISM',
  'terms.visual.stepdown': 'Step-down Trigger Levels',
  'terms.visual.chartAria': 'Step-down trigger level chart',
  'terms.visual.noSchedule': 'No trigger-level schedule identified',
  'terms.visual.triggerLegend': 'Trigger level (% of initial price)',
  'terms.visual.observationLegend': 'X-axis: observation number',
  'terms.visual.observation': 'Observation {index}',
  'terms.visual.strike': 'Strike Price',
  'terms.visual.knockIn': 'Knock-In Price',
  'terms.visual.riskBuffer': 'Risk buffer: {value}% below initial',
  'terms.visual.riskFloor': 'Risk floor: {value}% below initial',
  'terms.visual.strikeHint': 'Reference level for physical settlement after a trigger.',
  'terms.visual.knockInHint': 'A breach may expose the principal to loss.',
  'terms.visual.timelineKicker': 'KEY TIMELINE',
  'terms.visual.timeline': 'Trade, Start & Maturity',
  'terms.visual.tradeDate': 'Trade Date',
  'terms.visual.startDate': 'Start Date',
  'terms.visual.maturityDate': 'Maturity Date',
  'terms.visual.evidence': 'View OCR text and PDF evidence',
  'terms.visual.pagePdf': 'Preview PDF page {page}',

  // ── PDF modal extra ──
  'pdf.annotateRedaction': 'Annotate Redaction',
  'pdf.zoomAria': 'PDF zoom controls',
  'pdf.zoomOut': 'Zoom out',
  'pdf.zoomIn': 'Zoom in',
  'pdf.zoomReset': 'Reset to fit',
  'pdf.autoApplyHint': 'After {threshold} occurrences for this file type, same regions will be auto-applied.',
  'pdf.regionLabelPlaceholder': 'e.g. name_address',
  'pdf.saving': 'Saving',
  'pdf.remove': 'Remove',
  'pdf.delete': 'Delete',
  'pdf.ruleMeta': 'P{page} · x {x} / y {y} / w {w} / h {h} · used {count} times',
  'pdf.auto': '{label} · Auto',
  'pdf.learning': '{label} · Learning ({count})',
  'pdf.draft': '{label} · Pending',

  // ── PDF redaction actions ──
  'pdf.redactionSaveFailed': 'Failed to save redaction rule',
  'pdf.redactionSaved': 'Redaction rule saved, usage count: {count}',
  'pdf.confirmDeleteRule': 'Delete redaction rule "{label}"?',
  'pdf.redactionDeleteFailed': 'Failed to delete redaction rule',
  'pdf.redactionDeleted': 'Redaction rule deleted',

  // ── Docs extra ──
  'docs.confirmDelete': 'Delete archived file "{name}"?',

  // ── Interest detail drawer (extra keys) ──
  'interest.title': 'Loan Interest Details',
  'interest.hintAll': '{count} entries in current period, included in total return calculation.',
  'interest.hintScoped': '{matched} matched, {unassigned} unassigned.',
  'interest.financingNo': 'Financing No',
  'interest.stage': 'Stage',
  'interest.interest': 'Interest',
  'interest.linkedAsset': 'Linked Asset',
  'interest.unassigned': 'Unassigned',
  'interest.empty': 'No loan interest details for current period',

  // ── Language toggle ──
  'lang.toggle.zh': '中文',
  'lang.toggle.en': 'EN',
  'lang.aria': 'Language switch',
};

export const languages = { zh, en };
